// src/pages/AdminAcceptInvite.jsx — accept a KaiLux platform-admin invite.
// Mirrors AcceptInvite.jsx (firm team invites) but calls the platform-admin
// endpoint and lands in /admin, not /dashboard.
import { useState } from 'react'
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import { acceptAdminInvite } from '../api/kailux'
import { supabase } from '../supabase'
import ErrorMessage from '../components/ErrorMessage'


import { T, alpha } from '../theme/theme'
export default function AdminAcceptInvite() {
  const [params]   = useSearchParams()
  const token      = params.get('token') || ''
  const [password, setPassword] = useState('')
  const [confirm,  setConfirm]  = useState('')
  const [loading,  setLoading]  = useState(false)
  const [error,    setError]    = useState('')
  const [done,     setDone]     = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!token) { setError('This invite link is missing its token.'); return }
    if (password.length < 8) { setError('Password must be at least 8 characters'); return }
    if (password !== confirm) { setError('Passwords do not match'); return }
    setLoading(true); setError('')
    try {
      const data = await acceptAdminInvite(token, password)
      setDone(true)
      if (data.email) {
        await supabase.auth.signInWithPassword({ email: data.email, password })
      }
      setTimeout(() => navigate('/admin'), 1200)
    } catch (err) {
      setError(err.response?.data?.detail || 'Could not accept this invite. It may be invalid or already used.')
      setLoading(false)
    }
  }

  return (
    <div style={{ minHeight:'100vh', background:T.bg, display:'flex',
      alignItems:'center', justifyContent:'center', padding:'20px',
      fontFamily:"'Outfit',sans-serif", color:T.tx }}>
      <div style={{ width:'100%', maxWidth:'380px', background:T.s1,
        border:`1px solid ${T.bd}`, borderRadius:'16px', padding:'32px' }}>

        <div style={{ fontFamily:"'Syne',sans-serif", fontSize:'22px',
          fontWeight:'800', marginBottom:'6px' }}>
          {done ? 'Welcome to the KaiLux Admin Board!' : 'Join the KaiLux Admin Board'}
        </div>
        <div style={{ fontSize:'14px', color:T.mt, marginBottom:'22px' }}>
          {done
            ? 'Your account is set up — taking you to the Admin Board…'
            : 'Set a password to activate your admin account.'}
        </div>

        {!done && (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom:'14px' }}>
              <label style={{ display:'block', fontSize:'10px', fontWeight:'700',
                color:T.lt, letterSpacing:'1px', marginBottom:'6px' }}>PASSWORD</label>
              <input type="password" value={password} onChange={e=>setPassword(e.target.value)}
                placeholder="Min 8 characters"
                style={{ width:'100%', padding:'12px 14px', background:T.s2,
                  border:`1px solid ${T.bd}`, borderRadius:'10px', color:T.tx,
                  fontSize:'14px', fontFamily:"'Outfit',sans-serif", outline:'none',
                  boxSizing:'border-box' }} />
            </div>
            <div style={{ marginBottom:'18px' }}>
              <label style={{ display:'block', fontSize:'10px', fontWeight:'700',
                color:T.lt, letterSpacing:'1px', marginBottom:'6px' }}>CONFIRM PASSWORD</label>
              <input type="password" value={confirm} onChange={e=>setConfirm(e.target.value)}
                placeholder="Repeat password"
                style={{ width:'100%', padding:'12px 14px', background:T.s2,
                  border:`1px solid ${T.bd}`, borderRadius:'10px', color:T.tx,
                  fontSize:'14px', fontFamily:"'Outfit',sans-serif", outline:'none',
                  boxSizing:'border-box' }} />
            </div>

            {error && <ErrorMessage style={{ marginBottom:'14px' }}>{error}</ErrorMessage>}

            <button type="submit" disabled={loading}
              style={{ width:'100%', padding:'13px', borderRadius:'10px', border:'none',
                background: loading ? T.mt : T.prg,
                color:T.onpri, fontFamily:"'Outfit',sans-serif", fontSize:'15px',
                fontWeight:'800', cursor: loading ? 'not-allowed' : 'pointer' }}>
              {loading ? 'Activating…' : 'Activate Account'}
            </button>
          </form>
        )}

        {!done && (
          <div style={{ textAlign:'center', marginTop:'18px', fontSize:'13px', color:T.mt }}>
            Already have an account? <Link to="/login" style={{ color:T.or }}>Log in</Link>
          </div>
        )}
      </div>
    </div>
  )
}
